var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#55C194"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8522 6.24547C14.4847 5.70464 15.5205 5.70464 16.1622 6.24547L17.6105 7.49223C17.8855 7.73057 18.3988 7.92304 18.7655 7.92304H20.3239C21.2955 7.92304 22.093 8.72048 22.093 9.69214V11.2505C22.093 11.608 22.2855 12.1306 22.5238 12.4056L23.7705 13.8538C24.3114 14.4863 24.3114 15.5222 23.7705 16.1639L22.5238 17.6122C22.2855 17.8872 22.093 18.4005 22.093 18.7672V20.3256C22.093 21.2972 21.2955 22.0947 20.3239 22.0947H18.7655C18.408 22.0947 17.8855 22.2871 17.6105 22.5255L16.1622 23.7721C15.5297 24.313 14.4939 24.313 13.8522 23.7721L12.4039 22.5255C12.1289 22.2871 11.6155 22.0947 11.2489 22.0947H9.66301C8.69135 22.0947 7.89385 21.2972 7.89385 20.3256V18.758C7.89385 18.4005 7.70136 17.8872 7.47219 17.6122L6.23469 16.1547C5.70302 15.5222 5.70302 14.4955 6.23469 13.863L7.47219 12.4056C7.70136 12.1306 7.89385 11.6172 7.89385 11.2597V9.69214C7.89385 8.72048 8.69135 7.92304 9.66301 7.92304H11.2489C11.6064 7.92304 12.1289 7.73057 12.4039 7.49223L13.8522 6.24547Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0652 17.5838L14.3944 18.6105C14.5685 18.7847 14.9536 18.8672 15.2102 18.8672H16.8327C17.346 18.8672 17.9052 18.4822 18.0335 17.9689L19.0602 14.8338C19.271 14.238 18.8861 13.7155 18.2444 13.7155H16.5302C16.2736 13.7155 16.0627 13.5048 16.0994 13.2023L16.3102 11.8273C16.3927 11.4423 16.1361 11.0114 15.7511 10.8831C15.4119 10.7547 14.9811 10.9289 14.8069 11.1855L13.0469 13.798",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 17.5845V13.3862C10.875 12.7812 11.1317 12.5703 11.7367 12.5703H12.1675C12.7633 12.5703 13.0292 12.7812 13.0292 13.3862V17.5845C13.0292 18.1803 12.7725 18.4003 12.1675 18.4003H11.7367C11.1317 18.4003 10.875 18.1895 10.875 17.5845Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.c177d061c555abdfee124b6e9e002fe2.svg";
export { ForwardRef as ReactComponent };